import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMipsFileRepository from '../../reducers/mips-file-repository/mips-file-repository.reducer';

export const selectMipsFileRepositoryState = createFeatureSelector<fromMipsFileRepository.State>(
  fromMipsFileRepository.mipsFileRepositoryFeatureKey
);

export const selectFiles = createSelector(
  selectMipsFileRepositoryState,
  (state) => state.files
);

export const selectFilesLoading = createSelector(
  selectMipsFileRepositoryState,
  (state) => state.loading
);

export const selectFilesError = createSelector(
  selectMipsFileRepositoryState,
  (state) => state.error
);

export const selectDownloading = createSelector(
  selectMipsFileRepositoryState,
  (state) => state.downloading
);

export const selectViewing = createSelector(
  selectMipsFileRepositoryState,
  (state) => state.viewing
);
